import styled from 'styled-components';
import {Select, SelectForwardType} from '../Select';

export const StyledSelect = styled(Select)`` as SelectForwardType;
